import { DefaultLinkModel } from "@projectstorm/react-diagrams";

class CrossConnectLinkModel extends DefaultLinkModel {
  constructor() {
    super({
      type: "CrossConnect",
      width: 2,
      curvyness: 30,
    });
  }
  setCurvyness(curvyness: number) {
    this.options.curvyness = curvyness;
  }
}

export default CrossConnectLinkModel;
